import { KnowledgeBaseWorkerClient } from "./KnowledgeBaseWorkerClient"

export type FAQResponse = {
  id: string
  profile_id: string
  question: string
  answer: string
  created_at: string
  updated_at: string
}

export type FAQRequest = {
  question: string
  answer: string
}

export type ScrapedURLResponse = {
  id: string
  profile_id: string
  domain: string
  url: string
  path: string
  scraped_at: string
  content_length: number
}

export type PaginatedScrapedURLs = {
  items: ScrapedURLResponse[]
  total: number
  page: number
  page_size: number
  total_pages: number
}

export type DomainScrapingInfo = {
  id: string
  profile_id: string
  domain: string
  pages_count: number
  last_scraped_at: string
  created_at: string
  scraped_urls: PaginatedScrapedURLs
}

export type ScrapeDomainRequest = {
  domain: string
  max_pages?: number
}

export type ScrapeDomainResponse = {
  profile_id: string
  domain: string
  pages_scraped: number
  status: string
  message: string
  scraped_at: string
}

export type DeleteDomainResponse = {
  profile_id: string
  domain: string
  status: string
  message: string
}

const getFAQs = () =>
  KnowledgeBaseWorkerClient.get<null, FAQResponse[]>(`/profiles/:profileId/faqs`)

const updateFAQs = (faqs: FAQRequest[]) =>
  KnowledgeBaseWorkerClient.put<{ faqs: FAQRequest[] }, FAQResponse[]>(
    `/profiles/:profileId/faqs`,
    { faqs },
  )

const getScrapings = (page: number = 1, pageSize: number = 50) =>
  KnowledgeBaseWorkerClient.get<null, DomainScrapingInfo[]>(
    `/profiles/:profileId/scrapings?page=${page}&page_size=${pageSize}`,
  )

const scrapeDomain = (data: ScrapeDomainRequest) =>
  KnowledgeBaseWorkerClient.post<ScrapeDomainRequest, ScrapeDomainResponse>(
    `/profiles/:profileId/scrape-domain`,
    data,
  )

const deleteDomain = (domain: string) => {
  const encodedDomain = encodeURIComponent(domain)
  return KnowledgeBaseWorkerClient.delete<null, DeleteDomainResponse>(
    `/profiles/:profileId/scrapings/${encodedDomain}`,
  )
}

export const KnowledgeBaseService = {
  getFAQs,
  updateFAQs,
  getScrapings,
  scrapeDomain,
  deleteDomain,
}
